import { Component } from "react";
import { Modal } from "react-bootstrap";
import { popCancelBttn } from "../../assets";
import Button from "../Button";
import './GlobalSearchFeaturesPopUp.css'
import './PubMedSaveSearchPopup.css'
import ApiServices from "../../utils/apiServices";
import { snippetLongString } from "../../utils/utilityServices";
import AlertMessagePopUpModal from "./AlertMessagePopUpModal";
class RenamePubMedSaveSearchPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rlName: '',
            rlID: '',
            showSuccess: false,
            showPop: false,
            error: '',
            alertMessageModelColor: "",
            alertMessageContent: "",
            alertMessageShowModal: false,
            alertMessageIsError: false
        }
    }
    componentDidMount() {
        this.setState({
            showPop: this.props.showModal,
            rlName: this.props.rlName,
            rlID: this.props.rlID
        });
    }
    successAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#00c12c",
            alertMessageShowModal: true,
        })
    }
    errorAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#de1327",
            alertMessageShowModal: true,
            alertMessageIsError: true
        })
    }
    closeAlertMessage = () => {
        const { alertMessageIsError, showPop } = this.state;
        this.setState({
            alertMessageContent: "",
            alertMessageModelColor: "",
            showPop: alertMessageIsError ? showPop : false,
            alertMessageShowModal: false,
            alertMessageIsError: false,
        })
        if (!alertMessageIsError) {
            this.props.handleClose(false)
        }
    }
    handleOnClickView = async (rlID, rName) => {

        let ids = "";
        let service = new ApiServices();
        let res = await service.getPubMedDocIds(rlID);
        if (res.length > 0) {
            ids = res.map(item=>item.doc_id).filter(x=>x).join(";");
            // res.map((item) => {
            //     ids += `${item.doc_id};`;
            //     return null;
            // });
        }
        localStorage.setItem("readListDocIds", ids);
        localStorage.setItem("rLID", rlID);
        localStorage.setItem("rName", rName);
        let url = `/viewPubMedSaveSearch?query=&q=All%20Fields&filters=&f1=PMID&fval1=${ids}&fcount=1&rName=${encodeURIComponent(
            rName
        )}&rID=${rlID}`;
        if (ids !== "") {
            window.open(url, "_blank");
        } else {
            this.errorAlertMessage("You do not have any items pinned to this save search.");
        }


        // let ids = '';
        // let service = new ApiServices
        // let res = await service.getDocIds(rlID);
        // if (res.length > 0) {
        //     res.map((item) => { ids += `${item.doc_id};`; return null })
        // }
        // let url = `/results?query=&q=All%20Fields&filters=&f1=searchID&fval1=${ids}&fcount=1`
        // window.open(url, '_blank');
    }
    handleSuccessClose = (status) => {
        this.setState({
            showSuccess: status
        })
    }
    handleSave = async () => {
        if (this.handleValidation()) {
            let service = new ApiServices();
            let res = await service.updatePubMedSaveSearchName(this.state.rlID, this.state.rlName);
            if (res) {
                this.successAlertMessage('Save Search Name saved successfully');
            }
        }
    }
    handleInput = (e) => {
        e.target.value = snippetLongString(e.target.value);
        this.setState({
            rlName: e.target.value
        })
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        let saveSearchList = this.props.apiResponse.filter(x => x.savesearch_id !== this.state.rlID).map(data => data.savesearch_name.toLowerCase())
        if (this.state.rlName.length <= 0) {
            formIsValid = false;
            errors["pinSaveSearch"] = `Please enter a valid name to proceed.`;
        }
        if (saveSearchList.includes(this.state.rlName.toLowerCase())) {
            formIsValid = false;
            errors["pinSaveSearch"] = `You already have a save search with entered title. Please enter a new name.`;
        }
        this.setState({ error: errors });
        return formIsValid;
    }
    render() {
        const { alertMessageModelColor, alertMessageContent, alertMessageShowModal } = this.state;
        if (this.props.width <= 1000) {
            return (
                <>
                    <Modal
                        show={this.state.showPop}
                        size="lg md sm xs"
                        centered
                        aria-labelledby="contained-modal-title-vcenter"
                        dialogClassName="popup-transition"
                        scrollable={true}
                    >
                        <div style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}>
                            <div>
                                <Modal.Header className="gsfModalHeader" style={{ justifyContent: "left", padding: "0.5rem 0" }}>
                                    <div style={{ textAlign: "center", width: "100%", paddingTop: "1%" }}>
                                        <Modal.Title>
                                            <div className="actionItem-headerPart">
                                                Rename Save Search
                                            </div>
                                        </Modal.Title>
                                    </div>
                                </Modal.Header>
                                <Modal.Body scrollable={true} style={{ minHeight: "25vh" }}>
                                    <table className="save-search-view-wrapper">
                                        <tr><th>Save Search Name</th><th style={{ textAlign: "center" }}>Actions</th></tr>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "60%" }}><input type="text" value={this.state.rlName} onChange={this.handleInput} /><br /><div className="errorInvalidName">{this.state.error["pinSaveSearch"]}</div></td>
                                                <td style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", width: "100%" }}>
                                                    {/* <span onClick={e => this.handleOnClickView(this.props.rlID, this.props.rlName)} title="View" style={{ marginRight: "5px" }} className="save-search-action-text">View</span>
                                                    <span className="action-items-separate-divider"></span> */}
                                                    <span title="Save" onClick={e => this.handleSave()} className="save-search-action-text">Save</span></td>
                                            </tr>
                                            <span className="length-info">Name with a maximum of 100 characters.</span>
                                        </tbody>
                                    </table>
                                </Modal.Body>
                                <div className="save-search-button-tablet-wrapper">
                                    <Button text="Cancel" customColor="#000000" action={() => {
                                        this.setState({ showPop: false });
                                        this.props.handleClose(false);
                                    }} />
                                </div>
                            </div>
                        </div>
                    </Modal>
                    {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
                </>
            )
        }
        else {
            return (
                <>
                    <Modal
                        show={this.state.showPop}
                        size="lg md sm xs"
                        centered
                        aria-labelledby="contained-modal-title-vcenter"
                        dialogClassName="popup-transition"
                        scrollable={true}
                    >
                        <div style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}>
                            <div className="popup-cancel-btn-wrapper">
                                <img
                                    src={popCancelBttn}
                                    alt=""
                                    onClick={e => {
                                        this.setState({ showPop: false });
                                        this.props.handleClose(false);
                                    }}
                                />
                            </div>
                            <div>
                                <Modal.Header className="gsfModalHeader" style={{ justifyContent: "left" }}>
                                    <div style={{ textAlign: "center", width: "30%", paddingTop: "1%" }}>
                                        <Modal.Title>
                                            <div className="actionItem-headerPart">
                                                Rename Save Search
                                            </div>
                                        </Modal.Title>
                                    </div>
                                </Modal.Header>
                                <Modal.Body scrollable={true} style={{ minHeight: "25vh" }}>
                                    <table className="save-search-view-wrapper">
                                        <tr><th>Save Search Name</th><th style={{ textAlign: "center" }}>Actions</th></tr>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "60%" }}><input type="text" value={this.state.rlName} onChange={this.handleInput} /><br /><div className="errorInvalidName">{this.state.error["pinSaveSearch"]}</div></td>
                                                <td style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", width: "100%" }}>
                                                    {/* <span onClick={e => this.handleOnClickView(this.props.rlID, this.props.rlName)} title="View" style={{ marginRight: "5px" }} className="save-search-action-text">View</span>
                                                    <span className="action-items-separate-divider"></span> */}
                                                    <span title="Save" onClick={e => this.handleSave()} className="save-search-action-text">Save</span></td>
                                            </tr>
                                            <span className="length-info">Name with a maximum of 100 characters.</span>
                                        </tbody>
                                    </table>
                                </Modal.Body>
                                <div className="save-search-button-wrapper">
                                    <Button text="Cancel" customColor="#000000" action={() => {
                                        this.setState({ showPop: false });
                                        this.props.handleClose(false);
                                    }} />
                                </div>
                            </div>
                        </div>
                    </Modal>
                    {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
                </>
            )
        }
    }
}
export default RenamePubMedSaveSearchPopup;